import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { Button, ButtonGroup } from '@/common/components/button';
import { Description, Fieldset, Label, Legend } from '@/common/components/fieldset';
import { Heading } from '@/common/components/heading';
import { Radio, RadioField, RadioGroup } from '@/common/components/radio';

export const Route = createFileRoute(
  '/applications/$application-id/service-location/'
)({
  component: ServiceLocationComponent
});

function ServiceLocationComponent() {
  const navigate = useNavigate();
  const [serviceSelection, setServiceSelection] = useState<'existing' | 'new' | undefined>(undefined);

  const handleContinue = async () => {
    if (serviceSelection === 'existing') {
      await navigate({
        to: '/applications/$application-id/service-location/existing',
        params: {
          'application-id': '1'
        }
      });
    } else {
      await navigate({
        to: '/applications/$application-id/service-location/new',
        params: {
          'application-id': '1'
        }
      });
    }
  };

  return (
    <div className="p-8">
      <Heading>Service Location</Heading>

      <Fieldset>
        <Legend>What kind of service would you like to apply for?</Legend>

        <RadioGroup onChange={value => setServiceSelection(value as any as 'existing' | 'new')}>
          <RadioField>
            <Radio value="existing" />
            <Label>Existing Metered Service</Label>
            <Description>Apply for service at a location with an existing meter.</Description>
          </RadioField>

          <RadioField>
            <Radio value="new" />
            <Label>New Metered Service</Label>
            <Description>Apply to establish new service at a location that does not have a meter or to add an additional meter.</Description>
          </RadioField>
        </RadioGroup>
      </Fieldset>

      <ButtonGroup>
        <Button onClick={handleContinue} disabled={!serviceSelection}>Next</Button>
      </ButtonGroup>
    </div>
  );
}
